import React, { Component } from 'react';

import { track } from '../../../track';
import HubspotForm from '../hubspotForm';

import style from './style.scss';

export default class OtherSignup extends Component {
  componentDidMount() {
    track('signupFlow', {
      step: '/other-signup',
      productId: 2,
    });
  }

  render() {
    return (
      <div className={style.startContainer}>
        <HubspotForm formId='ba78f19f-1443-4345-9e87-a34323481912' />
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/components/signup/otherSignup.jsx
 **/